import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AngularMaterialDesignModule } from 'src/app/angular-material-design/module/angular-material-design.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { DynamicAutocompleteComponent } from 'src/app/shared/components/dynamic-autocomplete/dynamic-autocomplete.component';
import { FmsVccFilterModalComponent } from './fms-vcc-filter-modal.component';

@NgModule({
  declarations: [FmsVccFilterModalComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AngularMaterialDesignModule,
    SharedModule,
    DynamicAutocompleteComponent
  ],
  exports: [FmsVccFilterModalComponent]
})
export class FmsVccFilterModalModule {}
